import axiosBase from 'axios';

/**
 * Default configuration for axios calls.
 * NOTE: This should be used if your route in backend requires 'login_required()' check.
 */
const axios = axiosBase.create({
  // Always include credentials (cookies) for cross-origin requests
  withCredentials: true
});

export default axios;
